import type { ResourceDefinition } from './types.js';

/**
 * Identity with a type argument. It exists so a resource file reads as a
 * declaration and gets full inference on every callback (`cell`, `accessor`,
 * `onSelect`) without the author restating the item type at each one.
 */
export function defineResource<
  TItem,
  TValues extends Record<string, unknown> = Record<string, unknown>,
  TCreate = TValues,
  TUpdate = Partial<TValues>,
>(
  definition: ResourceDefinition<TItem, TValues, TCreate, TUpdate>,
): ResourceDefinition<TItem, TValues, TCreate, TUpdate> {
  return definition;
}
